module.exports = __webpack_public_path__ + "santacasapilar.jpg?f17aee425205caae46946561985e38b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/santacasapilar.jpg
// module id = 151
// module chunks = 0